import { missingInput, divisionByZero, incompleteCostBasis } from '../warnings';
import { formulaOk, formulaUnknown, type FormulaResult } from './types';

/**
 * SPEC-008 §23/METRIC-REQ-007 — CAC = acquisition cost / new customers.
 * `incompleteBasis` (from the caller's own cost-aggregation) adds a warning
 * instead of silently presenting a falsely precise number.
 */
export function cac(
  acquisitionCost: number | null,
  newCustomers: number | null,
  incompleteBasis = false,
): FormulaResult {
  const explanation = {
    metric: 'cac',
    formula: 'acquisitionCost / newCustomers',
    inputs: { acquisitionCost, newCustomers },
    result: null,
    unit: 'minor_currency_per_customer',
  };
  if (acquisitionCost === null || newCustomers === null) {
    return formulaUnknown(explanation, [missingInput('Acquisition cost and new customer count are both required to calculate CAC.')]);
  }
  if (newCustomers === 0) {
    return formulaUnknown(explanation, [divisionByZero('CAC is undefined when there are zero new customers.')]);
  }
  const warnings = incompleteBasis ? [incompleteCostBasis()] : [];
  return formulaOk(acquisitionCost / newCustomers, { ...explanation, result: acquisitionCost / newCustomers }, warnings);
}
